__webpack_require__.p = "/monsterforge/";